import React from 'react'

export const About = () => {
    return (
        <div
            style={{
                fontSize: '20px',
                textAlign: 'center'
            }}
        >
            С помощью этого приложения можно создавать персональные списки дел.
            <br />
            <br />
            <a href='https://github.com/vldslavvv/auth-todo' target='__blank'>GitHub</a>
        </div>
    )
}
